@if (accessManager.hasAccess(Permission.VIEW_WORKFLOW) && workflows$ | async; as workflows) {
  @if (workflows.length) {
    <div id="workflow-buttons">
      <button #workflow="matTooltip"
              [disabled]="remainingTokens === 0"
              [matMenuTriggerFor]="workflowMenu"
              [matTooltip]="'TOOLTIP.WORKFLOW' | translate : {remaining: remainingTokens, total: tokenLimit}"
              class="fx-layout-row fx-justify-center fx-align-center"
              mat-icon-button>
        <mat-icon fontSet="mdi" fontIcon="mdi-play-circle-outline" class="sm"></mat-icon>
      </button>
      <mat-menu #workflowMenu class="workflow-menu" [overlapTrigger]="false" id="workflowMenu" yPosition="below">
        @for (workflow of workflows; track workflow.id) {
          <div
            [matTooltip]="'TOOLTIP.WORKFLOW_ON_COOLDOWN' | translate: { cooldown: getWorkflowCooldownDisplay(workflow) }"
            [matTooltipDisabled]="getWorkflowCooldown(workflow) === 0"
            matTooltipPosition="right">
            <button (click)="executeWorkflow(workflow)"
                    [disabled]="isWorkflowDisabled(workflow) || loadingWorkflowIds.has(workflow.id)" mat-menu-item>
              <span>{{ workflow.config.btnParams.label }}</span>
            </button>
          </div>
        }
      </mat-menu>
    </div>
  }
}
